import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Returns a click handler for hash-based navigation (#faq, #hero, etc.).
 * If the user is already on the home page, scrolls smoothly without reload.
 * Otherwise, navigates to the home page with the hash.
 */
export function useSmartHashNav() {
  const location = useLocation();
  const { language } = useLanguage();

  const isHomePage =
    location.pathname === "/" ||
    location.pathname === `/${language}` ||
    location.pathname === `/${language}/`;

  const handleHashClick = (
    e: React.MouseEvent,
    targetId: string,
    closeMobileMenu?: () => void
  ) => {
    closeMobileMenu?.();

    if (isHomePage) {
      e.preventDefault();
      if (targetId === "hero") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
      }
    }
    // Otherwise, let the native <a href> handle cross-page navigation
  };

  return { handleHashClick, isHomePage };
}

